import axios, { AxiosResponse } from 'axios'
import { ID, Response } from '@/_metronic/helpers'
import {
  SalesRepartitionData,
  SalesEvolutionData,
  RestockData,
  SalesIndicatorsData
} from './_models'

const BASE_URL = '/p2c/reports/product'

interface IParams {
  from: Date;
  to: Date;
  userId?: ID;
  timezone: string;
}

// eslint-disable-next-line
const formatParams = (params?: Record<string, any>): Record<string, any> => {
  if (!params) return {};

  const formatted = Object.fromEntries(
    Object.entries(params).map(([key, value]) => {
      if (value instanceof Date) {
        const year = value.getFullYear();
        const month = String(value.getMonth() + 1).padStart(2, '0');
        const day = String(value.getDate()).padStart(2, '0');

        return [key, `${year}-${month}-${day}`];
      }
      return [key, value];
    })
  );

  return formatted;
};

/**
 * getSalesIndicators.
 */
export const getSalesIndicators = async (params: IParams): Promise<SalesIndicatorsData> => {
  return axios
    .get(`${BASE_URL}/indicators`, { params: formatParams(params) })
    .then((d: AxiosResponse<Response<SalesIndicatorsData>>) => d.data)
    .then((d: Response<SalesIndicatorsData>) => d.data || { order: 0, amount: 0 } as SalesIndicatorsData)
}

/**
 * getSalesRepartition.
 *
 * @returns {Promise<Array<SalesRepartitionData>>}
 */
const getSalesRepartition = async (params: IParams & { agg: string }): Promise<Array<SalesRepartitionData>> => {

  return axios
    .get(`${BASE_URL}/sales-repartition`, { params: formatParams(params) })
    .then((d: AxiosResponse<Response<Array<SalesRepartitionData>>>) => d.data)
    .then((d: Response<Array<SalesRepartitionData>>) => d.data || [])
}

/**
 * getSalesEvolution.
 * @returns {Promise<Array<SalesEvolutionData>>}
 */
const getSalesEvolution = async (params: IParams & { pad: string }): Promise<Array<SalesEvolutionData>> => {
  return axios
    .get(`${BASE_URL}/sales-evolution`, { params: formatParams(params) })
    .then((d: AxiosResponse<Response<Array<SalesEvolutionData>>>) => d.data)
    .then((d: Response<Array<SalesEvolutionData>>) => d.data || [])
}

const getRestocks = async (params: { from: Date, to: Date, timezone: string, pad: string }): Promise<Array<RestockData>> => {
  return axios
    .get(`${BASE_URL}/restocks`, { params: formatParams(params) })
    .then((d: AxiosResponse<Response<Array<RestockData>>>) => d.data)
    .then((d: Response<Array<RestockData>>) => d.data || [])
}

export {
  getSalesRepartition,
  getSalesEvolution,
  getRestocks
}
